import popupAlert from '@images/popup-alert.png';

import AccountFooter from '@components/account-footer/AccountFooter';
import { Modal } from '@components/index';
import { useAppDispatch } from '@core/store';
import { setNoBranchAccess } from '@layouts/main-header/userSlice';
import { Org } from 'types/organization';

interface NoBranchAccessModalProps {
  isOpen: boolean;
  orgList?: Org[];
  onSwitchAccount?: () => void;
}

const NoBranchAccessModal = ({
  isOpen,
  orgList = [],
  onSwitchAccount
}: NoBranchAccessModalProps) => {
  const dispatch = useAppDispatch();

  return (
    <Modal isOpen={isOpen} isClickOutsideRequired={false} className="w-120">
      <div className="flex flex-col items-center px-8 pb-6 pt-2">
        <img
          src={popupAlert}
          alt="alert"
          className="mb-4 h-28 w-full object-contain"
        />
        <h2 className="mb-3 text-center text-2xl font-semibold text-cofeeNeutral10">
          No branches available
        </h2>
        <p className="text-center text-base text-cofeeNeutral8">
          The branches you had access to are no longer available. Contact your
          organisation admin to regain access.
        </p>
      </div>
      <AccountFooter
        orgList={orgList}
        onSwitchAccount={onSwitchAccount}
        isCurrentOrgUnavailable
        // Clear the modal so the account-creation flow is not blocked by it.
        onBeforeCreateAccount={() => dispatch(setNoBranchAccess(false))}
      />
    </Modal>
  );
};

export default NoBranchAccessModal;
